import React, { useEffect, useState } from "react";
import Video from "../../Components/Section2/Video";
import SingleImg from "../../Components/All Category/SingleImg";
import "../../Components/style/FontFamilyUsing.css";
import SetLoader from "../../Components/loader/SetLoader";
import MainImageContainer from "../../Components/Bg Img container/MainImageContainer";
import SedctionTowImageContainer from "../../Components/Bg Img container/SedctionTowImageContainer";
import SectionThreeImageContainer from "../../Components/Bg Img container/SectionThreeImageContainer";
import MainProductDataShow from "../../Components/newproduct/MainProductDataShow";
import InstgramAdPage from "../../Components/Instagram/InstgramAdPage";
import SectionfourImageContainer from "../../Components/Bg Img container/SectionfourImageContainer";
import Newsletter from "../../Components/NEWSLETTER/Newsletter";
import ImageSilderContainer from "../../Components/image/ImageSilderContainer";

const Home = () => {
  const [loading, setLoading] = useState(false);


  useEffect(() => {
 
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      {loading ? (
        <SetLoader />
      ) : (
        <>
          <MainImageContainer />
          <SedctionTowImageContainer />
          <SectionfourImageContainer />
          <Video />
          <SectionThreeImageContainer />
          <MainProductDataShow />
          <InstgramAdPage />
          <SingleImg />
          <ImageSilderContainer />
          <Newsletter />
        </>
      )}
    </div>
  );
};

export default Home;
